export interface GoogleAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface ParsedAddress {
  street: string;
  zipCode: string;
  city: string;
  country: string;
}

const DEFAULT_COUNTRY = 'France';

const findLongName = (components: GoogleAddressComponent[], type: string): string =>
  components.find((component) => component.types.indexOf(type) !== -1)?.long_name ?? '';

export const parseGoogleAddress = (components: GoogleAddressComponent[]): ParsedAddress => {
  const streetNumber = findLongName(components, 'street_number');
  const route = findLongName(components, 'route');
  const locality = findLongName(components, 'locality');

  return {
    street: [streetNumber, route].filter(Boolean).join(' '),
    zipCode: findLongName(components, 'postal_code'),
    city: locality === '' ? findLongName(components, 'postal_town') : locality,
    country: findLongName(components, 'country') || DEFAULT_COUNTRY,
  };
};

export const buildAddressLabel = (address: ParsedAddress): string =>
  [address.street, address.zipCode, address.city].filter(Boolean).join(', ');
